<template>
  <f7-page>
    <div class="mx-auto w-11/12 sm:w-9/12 sm:min-w-150 mt-2 sm:mt-12 max-w-4xl">
      <div
        class="mx-auto my-10 sm:flex justify-between max-w-2xl"
      >
        <img
          class="w-24"
          src="@/assets/sensors.svg"
        >
        <div
          class="text-4xl font-bold mx-10"
        >
          Dispositivos control de acceso
        </div>
      </div>
      <div>
        <div class="flex space-x-2 justify-end flex-wrap">
          <a
            class="block bg-purple-500 text-white text-center text-2xl rounded-md py-2 my-2"
            href="/admin/firmware"
          >Firmware</a>
          <a
            class="block bg-green-500 text-white text-center text-2xl rounded-md py-2 my-2"
            @click="openModal = true"
          >+ Crear</a>
        </div>
      </div>
      <div class="flex flex-wrap flex-grow">
        <device-card
          v-for="device in devices"
          :key="device.id"
          :device="device"
          class="mr-2 mt-2"
        />
      </div>
    </div>
    <portal to="modals">
      <modal
        :open="openModal"
        type="custom"
        @close="openModal = false"
      >
        <div
          slot="content"
        >
          <device-card
            creating
            @close="openModal=false"
          />
        </div>
      </modal>
    </portal>
  </f7-page>
</template>

<script>
import { db } from '../utils/firebase'
import DeviceCard from '../components/deviceCard'
import Modal from '../components/modal'

export default {
  components: {
    DeviceCard,
    Modal,
  },
  data () {
    return {
      openModal: false,
      devices: [],
    }
  },
  mounted () {
    this.bindDevices()
    this.getVariants()
  },
  methods: {
    async getVariants () {
      const variants = await db.collection('hardware').doc('sensors').get()
      if (variants.exists) {
        this.$store.commit('admin/setVariants', variants.data().variants)
      }
      const firmwareList = await db.collection('hardware').doc('firmware').collection('uploads').get()
      if (!firmwareList.empty) {
        this.$store.commit('admin/setFirmwareList', firmwareList.docs)
      }
    },
    bindDevices () {
      db.collection('hardware').doc('sensors').collection('devices').orderBy('created_at').onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if (change.type === 'added') {
            this.devices.push({
              id: change.doc.id,
              ...change.doc.data(),
            })
          }
          if (change.type === 'modified') {
            this.devices = this.devices.map(device => {
              if (device.id === change.doc.id) {
                return {
                  id: change.doc.id,
                  ...change.doc.data(),
                }
              }
              return device
            })
          }
          if (change.type === 'removed') {
            this.devices.splice(this.devices.indexOf(change.doc.data()), 1)
          }
        })
      })
    },
  },
}
</script>
